import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { MessageSquare, Zap, Tag, Reply, Bot } from 'lucide-react'

import { cn } from '@/common/lib/utils'
import PageContainer from '@/common/components/PageContainer'
import Heading from '@/common/shared/heading'

const settingsTabs = [
	{
		path: '/operator/chat/settings/greeting',
		label: 'ข้อความต้อนรับ',
		icon: MessageSquare,
	},
	{
		path: '/operator/chat/settings/auto-reply',
		label: 'ตอบกลับอัตโนมัติ',
		icon: Reply,
	},
	{
		path: '/operator/chat/settings/tags',
		label: 'แท็กลูกค้า',
		icon: Tag,
	},
	{
		path: '/operator/chat/settings/quick-responses',
		label: 'ข้อความด่วน',
		icon: Zap,
	},
	{
		path: '/operator/chat/settings/ai',
		label: 'AI ผู้ช่วย',
		icon: Bot,
	},
]

export function ChatSettingsPage() {
	const location = useLocation()

	return (
		<PageContainer>
			<div className="mb-6">
				<Heading
					title="ตั้งค่าแชท"
					description="จัดการการตั้งค่าแชท LINE ข้อความต้อนรับ และการตอบกลับอัตโนมัติ"
				/>
			</div>

			{/* Tabs Navigation */}
			<div className="mb-6 border-b">
				<nav className="-mb-px flex space-x-8" aria-label="Tabs">
					{settingsTabs.map((tab) => {
						const isActive = location.pathname === tab.path

						return (
							<NavLink
								key={tab.path}
								to={tab.path}
								className={cn(
									'group inline-flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium transition-colors',
									isActive
										? 'border-primary text-primary'
										: 'border-transparent text-muted-foreground hover:border-muted-foreground/50 hover:text-foreground',
								)}
							>
								<tab.icon
									className={cn(
										'h-4 w-4',
										isActive
											? 'text-primary'
											: 'text-muted-foreground group-hover:text-foreground',
									)}
								/>
								{tab.label}
							</NavLink>
						)
					})}
				</nav>
			</div>

			{/* Content - Outlet for child routes */}
			<div className="space-y-6">
				<Outlet />
			</div>
		</PageContainer>
	)
}
